<script>
    import { onMount } from 'svelte';
    

    function generateRandomMaoInfo(length = 1000) {
      const words = [
        "Mao", "cat", "feline", "purr", "meow", "whiskers", "paw", "tail", "nap", "cuddle",
        "scratch", "yawn", "stretch", "curious", "playful", "aloof", "graceful", "nocturnal",
        "independent", "agile", "furry", "mischievous", "sleek", "catnip", "toy", "mouse",
        "yarn", "box", "sunbeam", "window", "perch", "climb", "jump", "hunt", "groom",
        "treats", "food", "water", "litter", "collar", "bell", "veterinarian", "adoption",
        "kitten", "adult", "senior", "breed", "domestic", "wild", "feral", "house cat",
        "big cat", "lion", "tiger", "cheetah", "leopard", "jaguar", "panther", "lynx",
        "bobcat", "cougar", "sphynx", "persian", "siamese", "maine coon", "bengal",
        "russian blue", "abyssinian", "ragdoll", "scottish fold", "british shorthair"
      ];
  
      const phrases = [
        "Mao demands attention",
        "The feline overlord yawns",
        "Cats rule the universe",
        "Meow for food",
        "Purring intensifies",
        "Whiskers twitch in curiosity",
        "Paws knead invisible dough",
        "Tail swishes with intent",
        "Nap time is sacred",
        "Cuddles on human terms only",
        "Scratching post emergency",
        "Stretch and yawn routine",
        "Mischief managed",
        "Sunbeam spotted",
        "Window watching intensifies",
        "Graceful leaps and bounds",
        "Nocturnal zoomies commence",
        "Independent spirit activated",
        "Agile maneuvers executed",
        "Grooming session in progress",
        "Treat time is the best time",
        "Water bowl investigation",
        "Litter box camouflage",
        "Collar jingle alerts prey",
        "Veterinarian visit anxiety",
        "Kitten energy overload",
        "Adult cat wisdom",
        "Senior cat nap marathon",
        "Breed-specific quirks observed",
        "Domestic bliss achieved",
        "Wild instincts surface",
        "Feral cat colony dynamics",
        "House cat luxury lifestyle",
        "Big cat dreams",
        "Lion's roar in a housecat's meow",
        "Tiger stripes imagined",
        "Cheetah speed in short bursts",
        "Leopard spots envied",
        "Jaguar stealth mode activated",
        "Panther prowl practiced",
        "Lynx ear tufts admired",
        "Bobcat attitude adopted",
        "Cougar confidence channeled",
        "Sphynx elegance displayed",
        "Persian fluff overload",
        "Siamese vocals perfected",
        "Maine Coon size aspirations",
        "Bengal patterns appreciated",
        "Russian Blue regality assumed",
        "Abyssinian curiosity peaked",
        "Ragdoll relaxation mastered",
        "Scottish Fold ear origami",
        "British Shorthair chubbiness goals"
      ];
  
      let result = "";
    while (result.length < length) {
      if (Math.random() < 0.3) {
        result += phrases[Math.floor(Math.random() * phrases.length)] + ". ";
      } else {
        result += words[Math.floor(Math.random() * words.length)] + " ";
      }
    }
    return result.trim();
  }

  let ascii = `
   /|_/|  
  ( o.o )        maocat.lol
   > ^ <
  `;

  let username = 'https://x.com/chikoYEAT 𝕏 @chikoyeat v0.1';
  let defaultContent = `${ascii}\n\nby ${username} \n\n${generateRandomMaoInfo(1000)}`;
    let editorContent = defaultContent;

    let showCommandInput = false;
    let commandInput = '';

    let colorScheme = '#fffae6';
    let vimMode = 'normal'; 
    let cursorStyle = 'block';
    let typingSound;


    onMount(() => {
      const savedContent = localStorage.getItem('editorContent');
      if (savedContent) {
        editorContent = savedContent;
      } else {
        editorContent = defaultContent;
      }
      updateLineNumbers();
      window.addEventListener('resize', updateLineNumbers);
      return () => window.removeEventListener('resize', updateLineNumbers);
      typingSound = new Audio('https://www.soundjay.com/communication/typewriter-1.mp3');
      typingSound.volume = 0.5; 
    });
    function saveToLocalStorage() {
      localStorage.setItem('editorContent', editorContent);
    }

    function playTypingSound() {
    if (typingSound) {
      typingSound.currentTime = 0; 
      typingSound.play();
    }
  }

  function handleInput(event) {
    updateLineNumbers();
    saveToLocalStorage();
    playTypingSound(); 
  }

    function reloadEditorContent() {
      const confirmed = confirm("Are you sure you want to reset the content?");
      if (confirmed) {
        editorContent = defaultContent;
        localStorage.removeItem('editorContent');
        saveToLocalStorage();  // Reset localStorage
        updateLineNumbers();
      }
    }

    let lineNumbers = [];
    let lineHeights = [];

    function updateLineNumbers() {
      const textarea = document.querySelector('.editor-content');
      if (!textarea) return;

      const lines = editorContent.split('\n');
      lineNumbers = [];
      lineHeights = [];

      lines.forEach((line, index) => {
        const dummySpan = document.createElement('span');
        dummySpan.textContent = line || ' ';
        dummySpan.style.whiteSpace = 'pre-wrap';
        dummySpan.style.wordWrap = 'break-word';
        dummySpan.style.visibility = 'hidden';
        dummySpan.style.width = `${textarea.clientWidth}px`;
        dummySpan.style.font = getComputedStyle(textarea).font;

        document.body.appendChild(dummySpan);
        const height = Math.ceil(dummySpan.offsetHeight / parseFloat(getComputedStyle(textarea).lineHeight));
        document.body.removeChild(dummySpan);

        lineNumbers.push(index + 1);
        lineHeights.push(height);
      });
    }
    
    let previousContent = editorContent;

    function moveCursor(direction, isHorizontal = false) {
    const textarea = document.querySelector('.editor-content');
    const selectionStart = textarea.selectionStart;
    const lines = editorContent.split('\n');
    let currentLine = editorContent.slice(0, selectionStart).split('\n').length - 1;

    if (isHorizontal) {
        // Move left or right
        if (direction > 0) {
            // Move right
            textarea.selectionStart = textarea.selectionEnd = Math.min(selectionStart + 1, editorContent.length);
        } else {
            // Move left
            textarea.selectionStart = textarea.selectionEnd = Math.max(selectionStart - 1, 0);
        }
    } else {
        // Move up or down
        if (direction > 0) {
            // Move down
            currentLine = Math.min(currentLine + 1, lines.length - 1);
        } else {
            // Move up
            currentLine = Math.max(currentLine - 1, 0);
        }
        const newLineStart = editorContent.split('\n').slice(0, currentLine).join('\n').length;
        textarea.selectionStart = textarea.selectionEnd = newLineStart;
    }

    textarea.focus();
}

function handleKeydown(event) {
    const textarea = document.querySelector('.editor-content');
    const selectionStart = textarea.selectionStart;
    const selectionEnd = textarea.selectionEnd;

    // Quick switch to visual mode on selection
    if (selectionStart !== selectionEnd) {
        vimMode = 'visual';
        cursorStyle = 'block';
        return;
    }

    if (vimMode === 'normal' && event.key === 'i') {
        event.preventDefault();
        vimMode = 'insert';
        cursorStyle = 'line';
        return;
    }

    if (vimMode === 'normal') {
        event.preventDefault();

        if (event.key === ':' && event.shiftKey) {
            showCommandInput = true;
            return;
        }
        if (event.key === 'h') {
            moveCursor(-1, true); // Move left
        } else if (event.key === 'j') {
            moveCursor(1, false); // Move down
        } else if (event.key === 'k') {
            moveCursor(-1, false); // Move up
        } else if (event.key === 'l') {
            moveCursor(1, true); // Move right
        } else if (event.key === 'v') {
            vimMode = 'visual';
            cursorStyle = 'block';
        } else if (event.key === 'u') {
            // Undo
            if (undoStack.length > 0) {
                editorContent = undoStack.pop(); 
                saveToLocalStorage();
            }
        } else if (event.key === 'd') {
            // Delete
            if (selectionStart !== selectionEnd) {
                undoStack.push(editorContent); 
                editorContent = editorContent.slice(0, selectionStart) + editorContent.slice(selectionEnd);
                textarea.selectionStart = textarea.selectionEnd = selectionStart; 
                saveToLocalStorage();
            }
        }
      } else if ((vimMode === 'insert' || vimMode === 'visual') && event.key === 'Escape') {
        event.preventDefault();
        vimMode = 'normal';
        cursorStyle = 'block';
    }

    if (vimMode === 'normal' || vimMode === 'visual') {
        undoStack.push(editorContent); 
    }
}

function handleCommand(event) {
    if (event.key === 'Enter') {
        executeCommand(commandInput);
        commandInput = '';
        showCommandInput = false;
    } else if (event.key === 'Escape') {
        showCommandInput = false;
    }
}


function executeCommand(command) {
  const [cmd, ...args] = command.trim().split(/\s+/);

  switch (cmd.toLowerCase()) {
    case 'colorscheme':
      if (args.length > 0) {
        colorScheme = args[0];
      } else {
        console.error('Colorscheme command requires a color argument');
      }
      break;

    case 'set':
      if (args.length > 0) {
        const setting = args[0].toLowerCase();
        switch (setting) {
          case 'number':
            showLineNumbers = true;
            break;
          case 'nonumber':
            showLineNumbers = false;
            break;
          default:
            console.error(`Unknown setting: ${setting}`);
        }
      } else {
        console.error('Set command requires an argument');
      }
      break;

    case 'w':
    case 'write':
      saveToLocalStorage();
      console.log('Content saved');
      break;

    case 'q':
    case 'quit':
      // Implement quit functionality (e.g., close tab or show confirmation)
      console.log('Quit command received');
      break;

    case 'wq':
      saveToLocalStorage();
      console.log('Content saved. Quit command received');
      break;

    case 'help':
      console.log('Available commands: colorscheme, set number/nonumber, w/write, q/quit, wq, help');
      break;

    default:
      console.error(`Unknown command: ${cmd}`);
  }
}
  </script>
  
  <main class="editor-wrapper" style="background-color: {colorScheme};">
    <div class="editor">
      <div class="editor-container">
        <div class="line-numbers">
          {#each lineNumbers as number, index}
            <span style="height: {lineHeights[index] * 1.5}rem;">{number}</span>
          {/each}
        </div>
        <textarea
          class="editor-content"
          bind:value={editorContent}
          on:input={handleInput}
          on:keydown={handleKeydown}
          style="caret-shape: {cursorStyle};"
        ></textarea>
      </div>
  
      {#if showCommandInput}
        <div class="command-input">
          <input 
            type="text" 
            bind:value={commandInput} 
            on:keydown={handleCommand}
            placeholder="Enter command..."
            autofocus
          />
        </div>
      {/if}
    </div>
    <div class="status-bar">
      <span class="mode-indicator">-- {vimMode.toUpperCase()} MODE --</span>
    </div>
  
    <!-- Reset Button -->
    <button on:click={reloadEditorContent} class="reset-btn">Reset</button>
  </main>
  
  
  
  
  <style>
    :global(body) {
      margin: 0;
      padding: 0;
      font-family: 'Fira Code', monospace;
    }
  
    .editor-wrapper {
      min-height: 100vh;
      width: 100%;
    }
  
    .editor {
      display: flex;
      min-height: 100vh;
      color: #000;
      position: relative;
    }
  

  
    .line-numbers span {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      min-height: 1.5rem;
      padding-right: 0.5rem;
    }
    .reset-btn {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    padding: 0.5rem 1rem;
    background-color: #ff6b6b;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .reset-btn:hover {
    background-color: #ff4a4a;
  }
  
    .editor-container {
  display: flex;
  overflow: auto; 
  flex-grow: 1;
}

.line-numbers {
  padding: 1rem 0.5rem;
  text-align: right;
  font-family: 'Fira Code', monospace;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  position: relative; 
}

.editor-content {
  padding: 1rem 0.5rem;
  white-space: pre-wrap;
  caret-color: black;
  word-wrap: break-word;
  flex-grow: 1;
  font-family: 'Fira Code', monospace;
  resize: none;
  border: none;
  background-color: transparent;
  overflow-y: auto; 
  line-height: 1.5rem;
  font-size: 1rem;
}

  
    .editor-content:focus {
      outline: none;
    }
  
    .command-input {
        width: 100vw;
    position: fixed;
    top: 98%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0.5rem;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    z-index: 500;
  }

  .command-input input {
    width: 100vw;
    padding: 0.5rem;
    border: none;
    background-color: transparent;
    color: white;
    font-size: 1rem;
    outline: none;
  }

  .status-bar {
    position: fixed;
    bottom: 0;
    left: 32px;
    right: 0;
    color: grey;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
  }

  .mode-indicator {
    font-weight: bold;
  }
  
    .command-input input {
      width: 100%;
      padding: 0.5rem;
      border: none;
      background-color: transparent;
      color: white;
      font-size: 1rem;
      outline: none;
    }
  </style>